//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"AngularTolerance",1,0],[0,"AttachFidelityCheckData",1,0],[0,"AutomaticallyCheckItemRevisions",1,0],[0,"HealGeometryOnImport",1,0],[0,"IgnoreUpdateOfIdenticalVersions",1,0],[0,"LoadConstructionGeometry",1,0],[0,"LoadProductManufacturingInformation",1,0],[0,"LoadSolidEdgeAssemblyFeatures",1,0],[0,"LoadSolidEdgeConstructionGeometry",1,0],[0,"LoadSolidEdgeProductManufacturingInformation",1,0],[0,"MinimumSmallEdgeLength",1,0],[0,"OnlyImportDesignParts",1,0],[0,"PerformFidelityCheckOnImport",1,0],[0,"PreserveNominalGeometry",1,0],[0,"ReferenceGeometryImportColor",1,0],[0,"ReferenceGeometryImportLayer",1,0],[0,"RemoveDiscontinuity",1,0],[0,"RemoveSelfIntersections",1,0],[0,"RemoveSmallEdges",1,0],[0,"RepairTolerance",1,0],[0,"RetainFidelityCheckingInformation",1,0],[0,"SaveComponentPartFilesDuringLoad",1,0],[0,"SuppressSurfaceModification",1,0],[0,"Tolerance",1,0],[0,"UseRepairTolerance",1,0],[0,"WireframeGeometryImportColor",1,0],[0,"WireframeGeometryImportLayer",1,0]],[],[]];
SPLM.Preferences.SessionNXGateway = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionNXGateway";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;